import React from "react";
import "../../styles/homeBanner/style.scss";
const HomeBanner = ({ handleScrollToPortion, ref }) => {
  return (
    <>
      <div className="banner-parent-container" ref={ref}>
        <div className="banner-left-container">
          <div className="banner-left-heading">
            Expert Solutions, Trusted Partner.
          </div>
          <div className="banner-left-description">
            We provide expert solutions that drive business success. As your
            trusted partner, we deliver innovative, tailored strategies that
            fuel growth and transformation.
          </div>
          <div className="left-btn-wrapper">
            <button
              className="our-services-btn"
              onClick={() => {
                handleScrollToPortion("Services");
              }}
            >
              Our Services
            </button>
            <button
              className="view-case-btn"
              onClick={() => {
                handleScrollToPortion("Case Studies");
              }}
            >
              View Case Studies{" "}
              <img
                className="view-case-arrow"
                src="/images/common/right-arrow-green.svg"
                alt="view-case-studies"
              />
            </button>
          </div>
        </div>
        <div className="banner-right-container">
          <img
            src="/images/banner/rightCircle.svg"
            alt="banner"
            className="circle-desktop"
          />
          <img
            src="/images/banner/mobileBanner.svg"
            alt="banner"
            className="circle-mobile"
          />
          <div className="circle-mobile empty-div"></div>
        </div>
      </div>
      <div className="mobile-banner-left-container">
        <div className="banner-left-heading">
          Expert Solutions, Trusted Partner.
        </div>
        <div className="banner-left-description">
          We provide expert solutions that drive business success. As your
          trusted partner, we deliver innovative, tailored strategies that fuel
          growth and transformation.
        </div>
        <div className="left-btn-wrapper">
          <button
            className="our-services-btn"
            onClick={() => {
              handleScrollToPortion("Services");
            }}
          >
            Our Services
          </button>
          <button
            className="view-case-btn"
            onClick={() => {
              handleScrollToPortion("Case Studies");
            }}
          >
            View Case Studies{" "}
            <img
              className="view-case-arrow"
              src="/images/common/right-arrow-green.svg"
              alt="view-case-studies"
            />
          </button>
        </div>
      </div>
    </>
  );
};

export default HomeBanner;
